import { dialogClasses } from '@mui/material'
import { Dialog, Box, type Sx } from '@dhl/theme'
import { swipeDialogClasses } from './classes'
import { DialogHeader } from './components/DialogHeader'
import type { ScrollableDialogBodyProps, SwipeDialogProps } from './types'

const styles: Record<string, Sx> = {
  title: {
    color: (theme) => theme.palette.common.black,
  },
  iconButton: {
    color: (theme) => theme.palette.grey[400],
    paddingRight: 0,
  },
  paper: {
    margin: 0,
    borderRadius: 0,
    border: 'none',
    borderTopLeftRadius: (theme) => theme.shape.borderRadius,
    borderTopRightRadius: (theme) => theme.shape.borderRadius,
    width: '100% !important',
  },
  customDialogPaper: {
    [`& .${dialogClasses.paper}`]: {
      border: 'none',
    },
  },
}

const ScrollableDialogBodyComponent = ({ children, sx }: ScrollableDialogBodyProps) => (
  <Box sx={{ pb: 2, overflowY: 'auto', ...sx }}>{children}</Box>
)

export const RegularDialogComponent = ({
  children,
  disableSwipe,
  fullWidth = true,
  maxWidth = 'xs',
  minHeightPercentage,
  onBack,
  onClose,
  onClosing,
  onOpen,
  preventScrollOnSwipe,
  regularDialogHeight,
  sx,
  title,
  closable = true,
  ...dialogProps
}: SwipeDialogProps) => {
  const handleClose = () => {
    onClosing?.()
    onClose?.({}, 'escapeKeyDown')
  }

  // Correctly handle both render-prop and ReactNode children
  const renderedChildren =
    typeof children === 'function'
      ? children({ ScrollableDialogBodyComponent }) // RegularDialog does not provide ScrollableDialogBody
      : children

  return (
    <Dialog
      className={swipeDialogClasses.root}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      sx={[styles.customDialogPaper, sx] as Sx}
      {...dialogProps}
    >
      <DialogHeader title={title} onClose={closable ? handleClose : undefined} onBack={onBack} />
      {renderedChildren}
    </Dialog>
  )
}
